import React,{Component} from 'react';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Label,
  FormGroup,
  FormText
} from 'reactstrap';

import MoneyDisplay from '../MoneyDisplay';

const MONEY_REGEX = /^[0-9]*\.?[0-9]?[0-9]?$/;

class MoneyInput extends Component {
  constructor(){
    super();

    this.state = {
      value:'',
      greaterThanMinimum:true
    };
  }

  componentWillMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue});
    } else if(this.props.value || this.props.value === 0){
      this.setState({value:this.props.value});
    }
  }

  handleChange(event){
    const rawValue = event.target.value,
      matchesRegex = MONEY_REGEX.test(rawValue),
      lastDigitIsPeriod = rawValue[rawValue.length - 1] === '.',
      parsedValue = parseFloat(rawValue);

    if(matchesRegex && rawValue.length === 1 && lastDigitIsPeriod){
      this.setState({value:'0.'});
    } else if(matchesRegex && lastDigitIsPeriod){
      this.setState({value:rawValue});
    } else if(matchesRegex){
      this.setState({value:rawValue});
      this.props.onChange(parsedValue);
    }
  }

  render(){
    const {
      name,
      placeholder,
      onBlur,
      onFocus,
      required,
      readOnly,
      disabled,
      warning,
      min,
      label
    } = this.props;

    const {
      value
    } = this.state;

    return (
      <FormGroup>
        {label.length > 0 && (
          <Label>{label}</Label>
        )}
        <InputGroup>
          <InputGroupAddon 
            addonType="prepend"
          >
            <InputGroupText style={{backgroundColor:disabled ? '#eceeef':'transparent'}}>
              USD $
            </InputGroupText>
          </InputGroupAddon>
          <Input
            id={this.props.id}
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={(e) => this.handleChange(e)}
            onBlur={(e) => onBlur(e)}
            onFocus={(e) => onFocus(e)}
            required={required}
            readOnly={readOnly}
            disabled={disabled}
          />
        </InputGroup>
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
        {(warning.length === 0 && value < min) && (
          <FormText className='FadedFeedback'>
            Must be at least <MoneyDisplay>{min}</MoneyDisplay>
          </FormText>
        )}
      </FormGroup>
    )
  }
}

MoneyInput.defaultProps = {
  onChange:() => {},
  onBlur:() => {},
  onFocus:() => {},
  name:'',
  required:false,
  min:0,
  placeholder:'',
  readOnly:false,
  disabled:false,
  warning:'',
  label:''
};

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/shared/components/MoneyInput/index.js